import React from "react";
import Challenge from "../../screens/challenges/Challenge";
import LeaderboardMobile from "../../screens/challenges/LeaderboardMobile";
import Leaderboard from "../../screens/challenges/LeaderboardPrivate";
import LeaderboardPublic from "../../screens/challenges/LeaderboardPublic";
import DefaultLayout from "../components/layouts/DefaultLayout";
import Navigate from "../navigation/navigate";
import { ChallengeProvider } from "../../screens/challenges/ChallengeContext";

const ChallengeWithProvider = () => (
  <ChallengeProvider>
    <Challenge />
  </ChallengeProvider>
);

export default {
  leaderboardDetails: {
    path: "/leaderboard-details",
    component: Leaderboard,
    exact: false,
    rootPath: true,
    authRequired: true,
    layout: DefaultLayout,
    navigate: () => Navigate.toPath("/leaderboard-details"),
  },
  challenge: {
    path: "/challenges",
    component: ChallengeWithProvider,
    exact: false,
    rootPath: true,
    authRequired: true,
    layout: DefaultLayout,
    navigate: () => Navigate.toPath("/challenges"),
  },
  leaderboard: {
    path: "/leaderboard",
    component: LeaderboardMobile,
    exact: false,
    rootPath: true,
    authRequired: false,
    layout: DefaultLayout,
  },
  leaderboardPublic: {
    path: "/leaderboard-public",
    component: LeaderboardPublic,
    exact: false,
    rootPath: true,
    authRequired: false,
    layout: DefaultLayout,
  },
};
